module.exports = __webpack_public_path__ + "img/modalIcon.6c9dc0de.png";